import { useState } from "react";

const PartnerLocationReadOnlyRow = ({ index, t, partnerLocationItem, handleDeleteClick, oddIdx, add, setError }) => {
	const [isSubmit, setIsSubmit] = useState(false);

	function submitComplete() {
		setIsSubmit(false);
	}

	function submitDelete(event, partnerLocationItem) {
		setError("");
		setIsSubmit(true);
		handleDeleteClick(event, partnerLocationItem, submitComplete);
	}

	return (
		<tr key={index}>
			<td className={oddIdx ? "list-td col text-wrap odd" : "list-td col text-wrap even"}>{partnerLocationItem.locationName + " - " + partnerLocationItem.departmentName}</td>
			<td className={oddIdx ? "list-td col odd" : "list-td col even"}>{partnerLocationItem.status}</td>
			<td className={oddIdx ? "list-td col col-md-auto odd" : "list-td col col-md-auto even"}>
				<div id="submit-spinner"
					className={isSubmit ? "spinner-border spinner-border-sm text-dark spinner-size" : "spinner-hide"}
				>
				</div>
				<button className={isSubmit ? "btn btn-primary btn-block me-4 pe-none" : "btn btn-primary btn-block"} onClick={(event) => submitDelete(event, partnerLocationItem)}>
					{partnerLocationItem.statusCode === 1 ? t("page.delete") : t("page.undelete")}</button>
			</td>
		</tr>
	)
}
export default PartnerLocationReadOnlyRow;